import { falImage } from 'shared/@generated/icons/falImage';
import { useRoute } from 'shared/library/routes/route';
import { View } from 'react-native';
import { Props, Breeder } from 'shared/@types';
import { Image } from 'shared/components/image';
import { Text } from 'shared/components/text';
import { Link } from 'shared/components/link';
import LikeButton from 'shared/components/like-button';
import { memo } from 'react';
import { Icon } from 'shared/components/icon';
import { getBreederImageAsset } from 'shared/library/get-breeder-image';

const BreederCard = memo(function BreederCard({ breeder }: Props<{ breeder: Breeder }>) {
  const route = useRoute();

  if (!breeder) {
    return null;
  }

  const breederImage = getBreederImageAsset(breeder);
  const breederCity = breeder.owners?.[0]?.city ?? breeder.users?.[0]?.city ?? '';

  return (
    <View className={'relative h-full'}>
      <View className={'absolute left-0 top-0 z-10 p-2'}>
        <LikeButton modelId={breeder.id} modelType={'App\\Models\\Breeder'} />
      </View>

      <Link
        containerClassName={'h-full bg-white'}
        href={route('breeders.show', { breeder: breeder.slug })}
        asBlock
      >
        {breederImage ? (
          <Image
            src={breederImage}
            alt={breeder.name}
            containerClassName={'aspect-4/3 w-full'}
            imageClassName={'rounded-t object-cover group-hover:opacity-75'}
            sizeType={'card'}
          />
        ) : (
          <View
            className={'bg-brand-cream aspect-4/3 w-full items-center justify-center rounded-t'}
          >
            <View className={'bg-brand-cream-dark/40 rounded-3xl p-4'}>
              <Icon icon={falImage} className={'text-brand-brown-dark/50 size-10'} />
            </View>
          </View>
        )}

        <View className={'border-brand-brown-dark/15 flex-1 rounded-b border border-t-0 p-3'}>
          <Text className={'truncate font-bold group-hover:underline'}>{breeder.name}</Text>
          <Text className={'text-brand-brown-dark/70 text-sm'}>{breederCity}</Text>
        </View>
      </Link>
    </View>
  );
});

export { BreederCard };
